import { Flex, Box } from "@chakra-ui/layout";
import { Col, Row } from "antd";
import { Text } from "@chakra-ui/react";
import SelectContaCategoria from "components/Input/SelectContaCategoria";
import SelectContaBancaria from "components/Input/SelectContaBancaria";
import { FiltroRelatorioDemonstrativoProps } from "./ModalFiltros";
import SelectCentroDeCusto from "../Input/SelectCentroDeCusto/index";

interface FormFiltrosProps {
  filtro: FiltroRelatorioDemonstrativoProps;
  onChangeFiltro: (v: Partial<FiltroRelatorioDemonstrativoProps>) => void;
}

function FormFiltros({ filtro, onChangeFiltro }: FormFiltrosProps) {
  return (
    <Flex flexDir="column" width="100%">
      <Box as={Row} mt="16px" gutter={16}>
        <Box as={Col} xs={24}>
          <Text fontSize="13px">Conta categoria</Text>
          <SelectContaCategoria
            multiple
            value={filtro.contaCategoriaIds}
            placeholder="Todas as contas categorias"
            onChange={(v) => {
              v.length
                ? onChangeFiltro({ contaCategoriaIds: v })
                : onChangeFiltro({ contaCategoriaIds: [] });
            }}
          />
        </Box>
      </Box>

      <Box as={Row} mt="16px" gutter={16}>
        <Box as={Col} xs={24}>
          <Text fontSize="13px">Conta bancária</Text>
          <SelectContaBancaria
            mode="multiple"
            onChange={(v) =>
              v.length
                ? onChangeFiltro({ contaBancariaIds: v })
                : onChangeFiltro({ contaBancariaIds: undefined })
            }
            value={filtro.contaBancariaIds}
            placeholder="Todas as contas bancárias"
          />
        </Box>
      </Box>

      <Box as={Row} mt="16px" gutter={16} mb={6}>
        <Box as={Col} md={24} mb={4}>
          <Text mb="2px" fontSize="13px">
            Centro de custo
          </Text>
          <SelectCentroDeCusto
            allowClear
            placeholder="Todos os centros de custo"
            value={filtro.centrosDeCustoIds}
            mode="multiple"
            onChange={(v) =>
              v.length
                ? onChangeFiltro({ centrosDeCustoIds: v })
                : onChangeFiltro({ centrosDeCustoIds: undefined })
            }
          />
        </Box>
      </Box>
    </Flex>
  );
}

export default FormFiltros;
